<template>
  <div>
    <div
      v-if="isSearching"
      class="has-text-centered"
    >
      <font-awesome-icon
        icon="redo-alt"
        class="search-spinner fa-spin"
      />
    </div>
    <div v-if="!isSearching">
      <transition name="fade">
        <domain-tip-container v-if="!hasResults && !searchError " />
        <div v-else>
          <domain-search-found
            v-if="!searchError && exactMatch"
            :search-term="searchTerm"
            :domains-found="domainsFound"
            @domainSelected="selectDomain"
          />
          <domain-search-not-found
            v-else-if="!searchError"
            :search-term="searchTerm"
            :domains-found="domainsFound"
            @domainSelected="selectDomain"
            @transferDomain="transferDomain"
          />
          <search-error
            v-else
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DomainTipContainer from './DomainTipContainer'
import DomainSearchFound from './DomainSearchFound'
import DomainSearchNotFound from './DomainSearchNotFound'
import SearchError from './SearchError'
import domainRegistrationMixin from '@/mixins/domain-registration'

export default {

  name: 'SearchHandler',
  components: {
    DomainTipContainer,
    DomainSearchFound,
    DomainSearchNotFound,
    SearchError
  },
  mixins: [domainRegistrationMixin],
  computed: {
    hasResults () {
      if (this.domainsFound.length > 0) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.setTldsByTenant()
  },
  methods: {
    selectDomain (domain) {
      this.$root.$emit('show::custom::modal', { name: 'register-domain', data: { name: 'domain', data: domain } })
    },
    transferDomain (val) {
      this.$router.push({ name: 'DomainTransfer', query: { term: this.searchTerm } })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.search-spinner {
  font-size: 136px;
  color: var(--primary-color-transparent);
  margin-top: 30px;
}
</style>
